'use client';

import Button from '@src/components/atoms/button';
import cn from 'classnames';

// Assets
import ICheckedBlack from '@public/svg/i-checked-black.jsx';

const ModalPropertyCategory = ({ onSelectPropertyCategory, selectedPropertyCategory }) => {
  const Options = [
    {
      id: 1,
      name: 'Menjual',
    },
    {
      id: 2,
      name: 'Sewakan',
    },
    {
      id: 3,
      name: 'Jual dan Sewakan',
    },
  ];

  return (
    <div>
      <div className="px-6 py-4">
        <p className="font-satoshi-bold text-[21px] leading-[25.2px] text-[#252526]">
          Ingin jual atau sewakan properti?
        </p>
        <p className="font-satoshi text-[14px] leading-[19.6px] text-[#686A68]">
          Pilih tujuan Anda menitipkan properti kepada kami.
        </p>
      </div>

      <div className="flex items-center flex-wrap gap-2 px-6 py-2">
        {!!Options?.length &&
          Options.map((list, index) => {
            const isSelected = selectedPropertyCategory?.id === list.id;
            return (
              <Button
                onClick={() => {
                  onSelectPropertyCategory(list);
                }}
                key={`list-property-${index}`}
                className={cn({
                  'h-[32px] !py-0 !px-[12px] !font-satoshi': true,
                  'bg-white !text-[#252526] border border-solid border-[#DEDFDE]':
                    !isSelected,
                  'bg-[#252526] !text-white': isSelected,
                })}
              >
                {list.name}
                {isSelected && <ICheckedBlack />}
              </Button>
            );
          })}
      </div>
    </div>
  );
};

export default ModalPropertyCategory;
